/*
 * Broadcast Theme – Custom JS
 * Keep your custom code inside this IIFE so nothing leaks to the global scope.
 */
(function () {
  'use strict';

  /**
   * Find the PDP metafield description inside the built-in
   * .toggle-ellipsis__content wrapper and add a marker class.
   * Your CSS targets .metafield--teaser for the fade/clamp effect.
   */
  function markPdpTeaser(root) {
    var ctx = root || document;
    var nodes = ctx.querySelectorAll(
      '[data-section-type="product"] .toggle-ellipsis__content > .metafield-rich_text_field:not(.metafield--teaser)'
    );
    if (!nodes || !nodes.length) return;
    nodes.forEach(function (el) { el.classList.add('metafield--teaser'); });
  }

  // Run on initial load
  document.addEventListener('DOMContentLoaded', function () {
    markPdpTeaser(document);
  });

  // Re-run when sections are injected/changed in the Theme Editor
  document.addEventListener('shopify:section:load', function (e) {
    markPdpTeaser(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    markPdpTeaser(e.target);
  });
  document.addEventListener('shopify:section:reorder', function (e) {
    markPdpTeaser(e.target);
  });
})();


